<div class="card-content"> 
    <mat-card appearance="outlined" class="card-model">
        <mat-card-header>
            <mat-card-title>
                <div class="title-card">
                    <span>Consulta Preço/Prazo</span>
                    <div fxFlex></div>
                    <button mat-mini-fab color="primary" matTooltip="Consultar Preço" (click)="consultar()" >
                        <mat-icon>search</mat-icon>
                    </button>
                    <div class="vl"></div>
                    <button mat-icon-button matTooltip="Configuração" (click)="openConfig()" >
                        <mat-icon>settings</mat-icon>
                    </button>
                </div>
            </mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <div class="cep">
                <div class="cep-content">
                    <div class="cep-fields-grid">
                        <div class="columns-data">
                            <mat-form-field appearance="outline" [formGroup]="formValidation" class="no-padding-form-field cep-font" >
                                <mat-label>CEP Origem</mat-label>
                                <input  matInput formControlName="origem" placeholder="CEP Origem"   #inp type = "text" mask="00000-000"> 
                            </mat-form-field>
                        </div>
                        <div class="columns-data">
                            <mat-form-field appearance="outline" [formGroup]="formValidation" class="no-padding-form-field cep-font" >
                                <mat-label>CEP Destino</mat-label>
                                <input  matInput formControlName="destino" placeholder="CEP Destino"   #inpDest type = "text" mask="00000-000"> 
                            </mat-form-field>
                        </div>
                        <div class="columns-data">
                            <mat-form-field appearance="outline" [formGroup]="formValidation" class="no-padding-form-field cep-font" mask="separator.2" thousandSeparator=".">
                                <mat-label>Valor Declarado</mat-label>
                                <input  matInput formControlName="vlrdeclarado" placeholder="Valor Declarado"   #inpDest type = "number" > 
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="cep-fields-grid">
                        <div class="columns-data-detail">
                            <mat-form-field appearance="outline" [formGroup]="formValidation" class="no-padding-form-field cep-font" matTooltip="Peso em Kilos"  mask="separator.2" thousandSeparator="."  >
                                <mat-label>Peso</mat-label>
                                <input  matInput formControlName="peso" placeholder="Peso"   #inp type = "number" > 
                            </mat-form-field>
                        </div>
                        <div class="columns-data-detail">
                            <mat-form-field appearance="outline" [formGroup]="formValidation" class="no-padding-form-field cep-font" matTooltip="Altura"  mask="separator.2" thousandSeparator=".">
                                <mat-label>Altura</mat-label>
                                <input  matInput formControlName="altura" placeholder="Altura"   #inp type = "number" > 
                            </mat-form-field>
                        </div>
                        <div class="columns-data-detail">
                            <mat-form-field appearance="outline" [formGroup]="formValidation" class="no-padding-form-field cep-font" matTooltip="Largura" mask="separator.2" thousandSeparator=".">
                                <mat-label>Largura</mat-label>
                                <input  matInput formControlName="largura" placeholder="Largura"   #inp type = "number" > 
                            </mat-form-field>
                        </div>
                        <div class="columns-data-detail">
                            <mat-form-field appearance="outline" [formGroup]="formValidation" class="no-padding-form-field cep-font" matTooltip="Diâmetro" mask="separator.2" thousandSeparator=".">
                                <mat-label>Diâmetro</mat-label>
                                <input  matInput formControlName="diametro" placeholder="Diâmetro"   #inp type = "number" > 
                            </mat-form-field>
                        </div>
                        <div class="columns-data-detail">
                            <mat-form-field appearance="outline" [formGroup]="formValidation" class="no-padding-form-field cep-font" matTooltip="Comprimento">
                                <mat-label>Comprimento</mat-label>
                                <input  matInput formControlName="comprimento" placeholder="Comprimento"   #inp type = "number" > 
                            </mat-form-field>
                        </div>
                    </div>
                </div>
                <div class="resultado"> 
                    <ul>
                        <li *ngFor="let item of mensagemObj">
                            <span class="key-class">{{item.key}}</span> -<span class="value-class"> {{item.value}}</span>
                        </li>
                    </ul>
                </div>
            </div>
        </mat-card-content>
    </mat-card>
</div>